import { LaunchdarklyService } from '@acesso-io/launchdarkly-client-ts/lib/launchdarkly';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleAnalyticsEventsService } from '@app/core/_shared/services/google-analytics/google-analytics-events.service';
import { getCurrentAccount, setCurrentAccount } from '@app/core/_shared/services/storage/storage.service';
import * as fromStore from '@app/modules/admission/_store';
import { EncryptService } from '@app/modules/admission/admission-profile/_shared/services/encrypt/encrypt.service';
import { Store, select } from '@ngrx/store';

declare let environment: any;

@Component({
  selector: 'app-sidebar-account',
  templateUrl: './sidebar-account.component.html',
  styleUrls: ['./sidebar-account.component.scss']
})
export class SidebarAccountComponent implements OnInit {
  private readonly signUrl: string = environment.sign_url;
  private readonly baseUrl: string = environment.base_url;
  private readonly benefits: string = environment.benefits_url;
  private readonly sign_people_product_id: string = environment.sign_people_product_id;

  @Input()
  set openMenu(open: boolean) {
    this.showMenu = open;

    setTimeout(() => {
      this.setFadeInAnimation();
    }, 100);
  }

  @Output() menu = new EventEmitter<boolean>();
  @Output() load = new EventEmitter<boolean>();

  url: string = environment.cdn_url;
  list: any;
  query: any;
  acc: any;
  showMenu = false;
  company = false;
  hasReportsPermission = false;
  hasSignature = false;
  benefitsURL: string = this.benefits + '/productivity';
  enableNewModelsList = false;
  isActivePath: string = 'admission';

  constructor(
    public router: Router,
    private readonly encryptService: EncryptService,
    private readonly store: Store<fromStore.DashboardState>,
    private readonly eventGa: GoogleAnalyticsEventsService,
    private readonly launchDarklyService: LaunchdarklyService
  ) {}

  ngOnInit() {
    this.setActivePath();

    this.store.pipe(select(fromStore.getOrganizationState)).subscribe(res => {
      this.list = res.groups;
      this.acc = res.currentAccount;
    });

    this.store.pipe(select(fromStore.getModulesEntities)).subscribe(res => {
      this.hasSignature = res.signature;
    });

    this.enableNewModelsList = this.checkFeatureFlag('people-rh-new-settings-models-list');
  }

  setActivePath() {
    const path = window.location.pathname.split('/');
    const pathname = path[1] + (path[2] ? `/${path[2]}` : '');

    if (!pathname) {
      this.isActivePath = 'admissions';
    } else {
      this.isActivePath = pathname;
    }
  }

  setFadeInAnimation() {
    const el = document.querySelector('.wrapper-menu');
    if (el) {
      el.classList.add('wrapper-menu-active');
    }
  }

  setFadeOutAnimation() {
    const el = document.querySelector('.wrapper-menu');
    if (el) {
      el.classList.remove('wrapper-menu-active');
    }
  }

  setFadeInCompany() {
    const el = document.querySelector('.sidebar-company-submenu');
    if (el) {
      el.classList.add('isOpen');
    }
  }

  setFadeOutCompany() {
    const el = document.querySelector('.sidebar-company-submenu');
    if (el) {
      el.classList.remove('isOpen');
    }
  }

  checkFeatureFlag(flag): boolean {
    return this.launchDarklyService.evaluateBoolean({ flagKey: flag });
  }

  toggleMenu() {
    this.setFadeOutAnimation();

    setTimeout(() => {
      this.menu.emit(false);
      document.body.classList.remove('sidebar-is-open');
      this.showMenu = false;
    }, 500);
  }

  changeCompany(uid) {
    const companies = this.list.reduce((all, item) => {
      item.accounts.map(res => {
        all.push(res);
      });
      return all;
    }, []);
    const account = companies.filter(x => x.uid === uid)[0];
    this.store.dispatch(new fromStore.ChangeAccout(account));
    setCurrentAccount(uid);
    this.router.navigate(['/']);
    location.reload();
  }

  handleCompaniesMenu() {
    if (this.company) {
      this.setFadeOutCompany();

      setTimeout(() => {
        this.company = false;
      }, 500);
    }

    if (!this.company) {
      this.company = true;
      setTimeout(() => {
        this.setFadeInCompany();
      }, 50);
    }
  }

  trackerEvent() {
    this.eventGa.emitEvent('Menu Lateral', 'Click Assinatura Eletrônica', this.acc.name);
    this.toggleMenu();
  }

  redirectToSign() {
    this.trackerEvent();
    const payload = {
      showMenu: true
    };

    const encodedPayload = encodeURIComponent(this.encryptService.encrypt(JSON.stringify(payload)));
    window.location.href = `${this.signUrl}/login-integration?product_id=${this.sign_people_product_id}&redirect_uri=${this.baseUrl}&token=${encodedPayload}`;
  }
}
